import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  CloseButton,
  Flex,
  IconType,
} from '@core/ui-elements'
import { FC } from 'react'
import {
  MdCheckCircle,
  MdCheckCircleOutline,
  MdInfo,
  MdOutlineHighlightOff,
  MdSignalWifiStatusbarConnectedNoInternet4,
  MdWifiOff,
} from 'react-icons/md'
import { PiWarningFill } from 'react-icons/pi'

import { IconName, IToastCardBase } from './Toasts.types'

export const iconMap: Record<IconName, IconType> = {
  'error-default': MdOutlineHighlightOff,
  'error-wifi': MdWifiOff,
  'low-wifi': MdSignalWifiStatusbarConnectedNoInternet4,
  'success-default': MdCheckCircleOutline,
  'warning-default': PiWarningFill,
  'info-default': MdInfo,
  'positive-default': MdCheckCircle,
}

export const getIcon = (iconName?: IconName) =>
  iconName ? iconMap[iconName] : undefined

export const ToastCardBase: FC<IToastCardBase> = ({
  title,
  description,
  variant,
  onClose,
  icon,
}) => (
  <Alert variant={variant}>
    {icon && <AlertIcon as={icon} />}
    <Flex flexDirection="column" overflow="hidden" width="100%">
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{description}</AlertDescription>
    </Flex>
    {onClose && <CloseButton size="sm" variant="toast" onClick={onClose} />}
  </Alert>
)
